// import {
//   Box,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   useTheme,
//   useMediaQuery,
//   Card,
//   CardContent,
//   Typography,
//   Grid,
//   Stack,
//   Chip as MuiChip,
//   Pagination,
//   Button,
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";

// import React, { useState, useEffect } from "react";

// const CompaniesTable = () => {
//   const theme = useTheme();
//   const isXs = useMediaQuery(theme.breakpoints.down("sm"));
//   const isSm = useMediaQuery(theme.breakpoints.between("sm", "md"));
//   const isMd = useMediaQuery(theme.breakpoints.between("md", "lg"));

//   const [searchTerm, setSearchTerm] = useState("");
//   const [filters, setFilters] = useState({
//     products: "",
//     country: "",
//     annualValue: "",
//     industry: "",
//   });
//   const [companies, setCompanies] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage] = useState(10); // You can make this configurable

//   // Fetch companies data from API
//   useEffect(() => {
//     const fetchCompanies = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch(
//           "http://localhost:3000/super-admin/company-details"
//         );
//         const result = await response.json();

//         if (result.success) {
//           //  API response to table format
//           const mappedCompanies = result.data.companies.map((company) => ({
//             id: company.company_id,
//             name: company.company_name || "N/A",
//             email: company.admin_email || "N/A",
//             registrationDate: company.created_at
//               ? new Date(company.created_at)
//                   .toLocaleDateString("en-GB", {
//                     day: "2-digit",
//                     month: "short",
//                     year: "numeric",
//                   })
//                   .replace(",", " -")
//                   .toUpperCase()
//               : "N/A",
//             country: company.location || "N/A",
//             website: company.website || "N/A",
//             companySize: company.company_size || "N/A",
//             activityStatus: company.status || "Inactive",
//             postJob: "-",
//             importCandidates: "-",
//             conductAssessment: "-",
//             buildRecruitmentPipeline: "-",
//           }));

//           setCompanies(mappedCompanies);
//         } else {
//           setError(result.message || "Failed to fetch companies");
//         }
//       } catch (err) {
//         setError("Error fetching data: " + err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCompanies();
//   }, []);

//   // Filter companies based on search term
//   const filteredCompanies = companies.filter((company) =>
//     company.name.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   // Pagination calculations
//   const totalPages = Math.ceil(filteredCompanies.length / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const endIndex = startIndex + itemsPerPage;
//   const currentCompanies = filteredCompanies.slice(startIndex, endIndex);

//   // Handle page change
//   const handlePageChange = (event, value) => {
//     setCurrentPage(value);
//   };

//   // Reset to first page when search changes
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [searchTerm]);

//   const getStatusColor = (status) => {
//     return status === "Active"
//       ? { backgroundColor: "#05CD99", color: "#FFFFFF" }
//       : { backgroundColor: "#FF6767", color: "#FFFFFF" };
//   };

//   const Chip = ({ label, style }) => (
//     <span
//       style={{
//         display: "inline-block",
//         padding: "4px 10px",
//         borderRadius: "12px",
//         fontSize: "12px",
//         fontWeight: "500",
//         whiteSpace: "nowrap",
//         ...style,
//       }}
//     >
//       {label}
//     </span>
//   );

//   const DropdownIcon = () => (
//     <svg
//       width="12"
//       height="12"
//       viewBox="0 0 12 12"
//       fill="none"
//       style={{ marginLeft: "8px" }}
//     >
//       <path
//         d="M3 4.5L6 7.5L9 4.5"
//         stroke="#9CA3AF"
//         strokeWidth="1.5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   );
//   const navigate = useNavigate();

//   const headers = [
//     "Name",
//     "Admin Email",
//     "Registration date",
//     "Country",
//     "Website",
//     "Company Size",
//     "Activity Status",
//     "Post a Job",
//     "Import Candidates",
//     "Conduct Assessment",
//     "Build Recruitment Pipeline",
//     "",
//   ];

//   // Loading state
//   if (loading) {
//     return (
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "400px",
//           fontSize: "16px",
//           color: "#64748b",
//         }}
//       >
//         Loading companies...
//       </Box>
//     );
//   }

//   // Error state
//   if (error) {
//     return (
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "400px",
//           fontSize: "16px",
//           color: "#ef4444",
//         }}
//       >
//         Error: {error}
//       </Box>
//     );
//   }

//   // Mobile Card View
//   const MobileCardView = () => (
//     <Box sx={{ p: 2 }}>
//       <Typography
//         variant="h5"
//         sx={{ mb: 3, fontWeight: 700, color: "#2B3674", fontFamily: "Outfit" }}
//       >
//         All Companies
//       </Typography>

//       {/* Mobile Search */}
//       <Box sx={{ mb: 3 }}>
//         <Box sx={{ position: "relative", mb: 2 }}>
//           <input
//             type="text"
//             placeholder="Search with name"
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             style={{
//               padding: "12px 44px 12px 16px",
//               border: "1px solid #e2e8f0",
//               borderRadius: "8px",
//               fontSize: "14px",
//               width: "100%",
//               backgroundColor: "white",
//               outline: "none",
//               color: "#1f2937",
//               boxSizing: "border-box",
//             }}
//           />
//           <svg
//             width="20"
//             height="20"
//             viewBox="0 0 24 24"
//             fill="none"
//             style={{
//               position: "absolute",
//               right: "14px",
//               top: "50%",
//               transform: "translateY(-50%)",
//               color: "#9ca3af",
//               pointerEvents: "none",
//             }}
//           >
//             <path
//               d="m21 21-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
//               stroke="currentColor"
//               strokeWidth="2"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             />
//           </svg>
//         </Box>

//         <button
//           style={{
//             backgroundColor: "#f59e0b",
//             color: "white",
//             border: "none",
//             padding: "12px 20px",
//             borderRadius: "8px",
//             cursor: "pointer",
//             fontWeight: "600",
//             fontSize: "14px",
//             width: "100%",
//           }}
//         >
//           📊 Export CSV
//         </button>
//       </Box>

//       {/* Mobile Cards */}
//       <Grid container spacing={2}>
//         {currentCompanies.map((company, index) => (
//           <Grid item xs={12} key={index}>
//             <Card sx={{ boxShadow: 1, borderRadius: 2 }}>
//               <CardContent>
//                 <Stack spacing={2}>
//                   <Box
//                     sx={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "center",
//                     }}
//                   >
//                     <Typography
//                       variant="h6"
//                       sx={{ color: "#3b82f6", fontWeight: 500 }}
//                     >
//                       {company.name}
//                     </Typography>
//                     <Chip
//                       label={company.activityStatus}
//                       style={getStatusColor(company.activityStatus)}
//                     />
//                   </Box>

//                   <Typography variant="body2" color="text.secondary">
//                     {company.email}
//                   </Typography>

//                   <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//                     <Chip
//                       label={`Size: ${company.companySize}`}
//                       style={{ backgroundColor: "#dbeafe", color: "#1e40af" }}
//                     />
//                     <Chip
//                       label={company.country}
//                       style={{ backgroundColor: "#dcfce7", color: "#16a34a" }}
//                     />
//                   </Box>

//                   <Typography variant="caption" color="text.secondary">
//                     {company.website}
//                   </Typography>
//                 </Stack>
//               </CardContent>
//             </Card>
//           </Grid>
//         ))}
//       </Grid>

//       {/* Mobile Pagination */}
//       {totalPages > 1 && (
//         <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
//           <Pagination
//             count={totalPages}
//             page={currentPage}
//             onChange={handlePageChange}
//             size="small"
//             sx={{
//               "& .MuiPaginationItem-root": {
//                 fontFamily: "Outfit",
//               },
//             }}
//           />
//         </Box>
//       )}
//     </Box>
//   );

//   // Desktop/Tablet Table View
//   const TableView = () => (
//     <Box
//       sx={{
//         p: { xs: 1, sm: 2, md: 3 },
//         backgroundColor: "#fff",
//         ml: { xs: 0, sm: 0, md: 4, lg: "238px" },
//         fontFamily:
//           "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
//       }}
//     >
//       <Paper
//         sx={{
//           backgroundColor: "white",
//           borderRadius: "8px",
//           boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
//           overflow: "hidden",
//         }}
//       >
//         {/* Header */}
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: { xs: "column", sm: "column", md: "row" },
//             justifyContent: "space-between",
//             alignItems: { xs: "stretch", sm: "stretch", md: "center" },
//             p: { xs: 2, sm: 3, md: "24px 32px" },
//             borderBottom: "1px solid #f0f1f3",
//             backgroundColor: "white",
//             gap: { xs: 2, sm: 2, md: 0 },
//           }}
//         >
//           <Typography
//             variant="h4"
//             sx={{
//               fontSize: { xs: "20px", sm: "22px", md: "24px" },
//               fontWeight: "600",
//               color: "#1a202c",
//               mb: { xs: 0, sm: 0, md: 0 },
//               textAlign: { xs: "left", sm: "left", md: "left" },
//             }}
//           >
//             All companies
//           </Typography>

//           {/* Filters and Controls */}
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: { xs: "column", sm: "row" },
//               alignItems: { xs: "stretch", sm: "center" },
//               gap: { xs: 1.5, sm: 2 },
//               flexWrap: "wrap",
//             }}
//           >
//             {/* Filter Dropdowns Row */}
//             <Box
//               sx={{
//                 display: "flex",
//                 gap: { xs: 1, sm: 1.5 },
//                 flexWrap: "wrap",
//                 width: { xs: "100%", sm: "auto" },
//               }}
//             >
//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   p: { xs: "6px 12px", sm: "8px 16px" },
//                   borderRadius: "6px",
//                   fontSize: { xs: "12px", sm: "14px" },
//                   backgroundColor: "white",
//                   cursor: "pointer",
//                   flex: { xs: "1", sm: "0 0 auto" },
//                   minWidth: { xs: "0", sm: "90px" },
//                   justifyContent: "center",
//                   fontFamily: "Roboto",
//                   border: "1px solid #DDDDDD",
//                   fontWeight: 600,
//                   color: "#595959",
//                 }}
//               >
//                 Products
//                 <DropdownIcon />
//               </Box>

//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   p: { xs: "6px 12px", sm: "8px 16px" },
//                   borderRadius: "6px",
//                   fontSize: { xs: "12px", sm: "14px" },
//                   backgroundColor: "white",
//                   cursor: "pointer",
//                   flex: { xs: "1", sm: "0 0 auto" },
//                   minWidth: { xs: "0", sm: "90px" },
//                   justifyContent: "center",
//                   fontFamily: "Roboto",
//                   border: "1px solid #DDDDDD",
//                   fontWeight: 600,
//                   color: "#595959",
//                 }}
//               >
//                 Country
//                 <DropdownIcon />
//               </Box>

//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   p: { xs: "6px 12px", sm: "8px 16px" },
//                   borderRadius: "6px",
//                   fontSize: { xs: "12px", sm: "14px" },
//                   backgroundColor: "white",
//                   cursor: "pointer",
//                   flex: { xs: "1", sm: "0 0 auto" },
//                   minWidth: { xs: "0", sm: "110px" },
//                   justifyContent: "center",
//                   fontFamily: "Roboto",
//                   border: "1px solid #DDDDDD",
//                   fontWeight: 600,
//                   color: "#595959",
//                 }}
//               >
//                 Annual value
//                 <DropdownIcon />
//               </Box>

//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   p: { xs: "6px 12px", sm: "8px 16px" },
//                   borderRadius: "6px",
//                   fontSize: { xs: "12px", sm: "14px" },
//                   backgroundColor: "white",
//                   cursor: "pointer",
//                   flex: { xs: "1", sm: "0 0 auto" },
//                   minWidth: { xs: "0", sm: "90px" },
//                   justifyContent: "center",
//                   fontFamily: "Roboto",
//                   border: "1px solid #DDDDDD",
//                   fontWeight: 600,
//                   color: "#595959",
//                 }}
//               >
//                 Industry
//                 <DropdownIcon />
//               </Box>
//             </Box>

//             {/* Search and Export Row */}
//             <Box
//               sx={{
//                 display: "flex",
//                 gap: { xs: 1, sm: 2 },
//                 width: { xs: "100%", sm: "auto" },
//                 flexDirection: { xs: "column", sm: "row" },
//               }}
//             >
//               {/* Search Input */}
//               <Box
//                 sx={{
//                   position: "relative",
//                   display: "flex",
//                   alignItems: "center",
//                   flex: { xs: "1", sm: "0 0 auto" },
//                 }}
//               >
//                 <input
//                   type="text"
//                   placeholder="Search with name"
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   style={{
//                     padding: isXs ? "8px 40px 8px 12px" : "10px 44px 10px 16px",
//                     borderRadius: "6px",
//                     fontSize: isXs ? "13px" : "14px",
//                     width: "100%",
//                     backgroundColor: "white",
//                     outline: "none",
//                     transition: "all 0.2s ease",
//                     boxSizing: "border-box",
//                     fontFamily: "Roboto",
//                     border: "1px solid #DDDDDD",
//                     fontWeight: 400,
//                     color: "#848694",
//                   }}
//                   onFocus={(e) => {
//                     e.target.style.borderColor = "#3b82f6";
//                     e.target.style.boxShadow =
//                       "0 0 0 2px rgba(59, 130, 246, 0.1)";
//                   }}
//                   onBlur={(e) => {
//                     e.target.style.borderColor = "#e2e8f0";
//                     e.target.style.boxShadow = "none";
//                   }}
//                 />
//                 <svg
//                   width={isXs ? "16" : "20"}
//                   height={isXs ? "16" : "20"}
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   style={{
//                     position: "absolute",
//                     right: isXs ? "10px" : "14px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     color: "#9ca3af",
//                     pointerEvents: "none",
//                   }}
//                 >
//                   <path
//                     d="m21 21-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                 </svg>
//               </Box>

//               {/* Export Button */}
//               <button
//                 style={{
//                   backgroundColor: "#f59e0b",
//                   padding: isXs ? "8px 16px" : "10px 20px",
//                   borderRadius: "6px",
//                   cursor: "pointer",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "8px",
//                   fontSize: isXs ? "13px" : "14px",
//                   whiteSpace: "nowrap",
//                   transition: "background-color 0.2s ease",
//                   justifyContent: "center",
//                   minWidth: isXs ? "120px" : "auto",
//                   fontFamily: "Outfit",
//                   border: "none",
//                   fontWeight: 700,
//                   color: "#FFFFFF",
//                 }}
//                 onMouseEnter={(e) => {
//                   e.target.style.backgroundColor = "#d97706";
//                 }}
//                 onMouseLeave={(e) => {
//                   e.target.style.backgroundColor = "#f59e0b";
//                 }}
//               >
//                 📊 Export CSV
//               </button>
//             </Box>
//           </Box>
//         </Box>

//         {/* Table Container with Custom Scrollbar */}
//         <TableContainer
//           sx={{
//             overflowX: "auto",
//             // Custom scrollbar styles
//             "&::-webkit-scrollbar": {
//               height: "8px",
//             },
//             "&::-webkit-scrollbar-track": {
//               background: "#f1f5f9",
//               borderRadius: "4px",
//             },
//             "&::-webkit-scrollbar-thumb": {
//               background: "linear-gradient(135deg, #9048FB 0%, #7c3aed 100%)",
//               borderRadius: "4px",
//               transition: "background 0.3s ease",
//             },
//             "&::-webkit-scrollbar-thumb:hover": {
//               background: "linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)",
//             },
//             // For Firefox
//             scrollbarWidth: "thin",
//             scrollbarColor: "#9048FB #f1f5f9",
//           }}
//         >
//           <Table sx={{ minWidth: { xs: 800, sm: 1000, md: 1200 } }}>
//             <TableHead>
//               <TableRow sx={{ backgroundColor: "#fafbfc" }}>
//                 {headers.map((header, index) => {
//                   // Hide some columns on smaller screens
//                   if (
//                     isSm &&
//                     (index === 2 || index === 3 || index === 6 || index === 10)
//                   )
//                     return null;
//                   if (isMd && (index === 2 || index === 6)) return null;

//                   return (
//                     <TableCell
//                       key={index}
//                       sx={{
//                         p: { xs: "12px 8px", sm: "14px 12px", md: "16px 20px" },
//                         fontWeight: "500",
//                         fontSize: { xs: "12px", sm: "13px" },
//                         color: "#A3AED0",
//                         borderBottom: "1px solid #f1f5f9",
//                         whiteSpace: "nowrap",
//                         fontFamily: "Outfit",
//                       }}
//                     >
//                       <Box
//                         sx={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: "6px",
//                         }}
//                       >
//                         {header}
//                         {index < 10 && (
//                           <svg
//                             width="14"
//                             height="14"
//                             viewBox="0 0 14 14"
//                             fill="none"
//                           >
//                             <path
//                               d="M7 4L9 6H5L7 4ZM7 10L5 8H9L7 10Z"
//                               fill="#CBD5E1"
//                             />
//                           </svg>
//                         )}
//                       </Box>
//                     </TableCell>
//                   );
//                 })}
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {currentCompanies.map((company, index) => (
//                 <TableRow
//                   key={index}
//                   sx={{
//                     borderBottom: "1px solid #f8fafc",
//                     backgroundColor: "white",
//                   }}
//                 >
//                   {/* <TableCell
//                     sx={{
//                       p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
//                       fontSize: { xs: "13px", sm: "14px" },
//                       color: "#34394B",
//                       fontFamily: "Outfit",
//                       fontWeight: 400,
//                     }}
//                   >
//                     {company.id}
//                   </TableCell> */}
//                   {/* Name */}
//                   <TableCell
//                     sx={{
//                       p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
//                       minWidth: "200px", // Add minimum width
//                       maxWidth: "250px", // Add maximum width
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: "12px",
//                       }}
//                     >
//                       <span
//                         style={{
//                           color: "#9048FB",
//                           fontSize: "15px",
//                           fontWeight: "600",
//                           fontFamily: "Outfit",
//                           whiteSpace: "nowrap", // Prevent text wrapping
//                           overflow: "hidden", // Hide overflow text
//                           textOverflow: "ellipsis", // Add ... for long names
//                           display: "block",
//                           maxWidth: "100%",
//                         }}
//                       >
//                         {company.name}
//                       </span>
//                     </Box>
//                   </TableCell>

//                   {/* Email */}
//                   <TableCell
//                     sx={{
//                       p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
//                       fontSize: { xs: "13px", sm: "14px" },
//                       color: "#34394B",
//                       fontFamily: "Outfit",
//                       fontWeight: 400,
//                     }}
//                   >
//                     {company.email}
//                   </TableCell>

//                   {/* Registration Date - Hidden on sm */}
//                   {!isSm && (
//                     <TableCell
//                       sx={{
//                         p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
//                         fontSize: { xs: "13px", sm: "14px" },
//                         color: "#34394B",
//                         fontFamily: "Outfit",
//                         fontWeight: 400,
//                       }}
//                     >
//                       {company.registrationDate}
//                     </TableCell>
//                   )}

//                   {/* Country - Hidden on sm */}
//                   {!isSm && (
//                     <TableCell
//                       sx={{
//                         p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
//                         fontSize: { xs: "13px", sm: "14px" },
//                         color: "#34394B",
//                         fontFamily: "Outfit",
//                         fontWeight: 400,
//                       }}
//                     >
//                       {company.country}
//                     </TableCell>
//                   )}

//                   {/* Website */}
//                   {/* Website */}
//                   {/* Website */}
//                   <TableCell
//                     sx={{
//                       p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
//                       fontSize: { xs: "13px", sm: "14px" },
//                       color: "#34394B",
//                       fontFamily: "Outfit",
//                       fontWeight: 400,
//                       minWidth: "200px", // Same as Name cell
//                       maxWidth: "250px", // Same as Name cell
//                     }}
//                   >
//                     {company.website !== "N/A" ? (
//                       <Box
//                         sx={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: "8px",
//                           maxWidth: "100%", // Changed from "150px" to "100%" to use full cell width
//                         }}
//                       >
//                         <span
//                           style={{
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             whiteSpace: "nowrap",
//                             maxWidth: "calc(100% - 24px)", // Adjusted to account for icon space
//                           }}
//                         >
//                           {company.website.length > 30 // Increased from 20 to 30 to show more text
//                             ? `${company.website.substring(0, 30)}...`
//                             : company.website}
//                         </span>
//                         <svg
//                           width="16"
//                           height="16"
//                           viewBox="0 0 24 24"
//                           fill="none"
//                           style={{
//                             cursor: "pointer",
//                             color: "#9048FB",
//                             flexShrink: 0,
//                           }}
//                           onClick={() => {
//                             const url = company.website.startsWith("http")
//                               ? company.website
//                               : `https://${company.website}`;
//                             window.open(url, "_blank");
//                           }}
//                         >
//                           <path
//                             d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
//                             stroke="currentColor"
//                             strokeWidth="2"
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                           />
//                           <polyline
//                             points="15,3 21,3 21,9"
//                             stroke="currentColor"
//                             strokeWidth="2"
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                           />
//                           <line
//                             x1="10"
//                             y1="14"
//                             x2="21"
//                             y2="3"
//                             stroke="currentColor"
//                             strokeWidth="2"
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                           />
//                         </svg>
//                       </Box>
//                     ) : (
//                       "N/A"
//                     )}
//                   </TableCell>

//                   {/* Company Size */}
//                   <TableCell
//                     sx={{ p: { xs: "12px 8px", sm: "16px 12px", md: "20px" } }}
//                   >
//                     <Chip
//                       label={company.companySize}
//                       style={{
//                         backgroundColor: "#4BC7E1",
//                         color: "#FFFFFF",
//                         fontFamily: "Roboto",
//                         fontSize: "14px",
//                       }}
//                     />
//                   </TableCell>

//                   {/* Activity Status */}
//                   <TableCell
//                     sx={{ p: { xs: "12px 8px", sm: "16px 12px", md: "20px" } }}
//                   >
//                     <Chip
//                       label={company.activityStatus}
//                       style={{
//                         ...getStatusColor(company.activityStatus),
//                         color: "#FFFFFF",
//                         fontFamily: "Roboto",
//                         fontSize: "14px",
//                       }}
//                     />
//                   </TableCell>

//                   {/* Post a Job */}
//                   <TableCell
//                     sx={{
//                       p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
//                       fontSize: { xs: "13px", sm: "14px" },
//                       color: "#34394B",
//                       fontFamily: "Outfit",
//                       fontWeight: 400,
//                     }}
//                   >
//                     -{/* {company.postJob} */}
//                   </TableCell>

//                   {/* Import Candidates */}
//                   <TableCell
//                     sx={{
//                       p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
//                       fontSize: { xs: "13px", sm: "14px" },
//                       color: "#34394B",
//                       fontFamily: "Outfit",
//                       fontWeight: 400,
//                     }}
//                   >
//                     -{/* {company.importCandidates} */}
//                   </TableCell>

//                   {/* Conduct Assessment */}
//                   <TableCell
//                     sx={{
//                       p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
//                       fontSize: { xs: "13px", sm: "14px" },
//                       color: "#34394B",
//                       fontFamily: "Outfit",
//                       fontWeight: 400,
//                     }}
//                   >
//                     -{/* {company.conductAssessment} */}
//                   </TableCell>

//                   {/* Build Recruitment Pipeline */}
//                   <TableCell
//                     sx={{
//                       p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
//                       fontSize: { xs: "13px", sm: "14px" },
//                       color: "#34394B",
//                       fontFamily: "Outfit",
//                       fontWeight: 400,
//                     }}
//                   >
//                     -{/* {company.buildRecruitmentPipeline} */}
//                   </TableCell>
//                   <TableCell
//                     sx={{
//                       p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
//                       textAlign: "center",
//                     }}
//                   >
//                     <Button
//                       onClick={() => {
//                         navigate("/TwoTabsPage", {
//                           // state: { companyId: company.id, company: company },
//                         });
//                       }}
//                       style={{
//                         backgroundColor: "#9048FB",
//                         color: "white",
//                         border: "none",
//                         padding: "8px 16px",
//                         borderRadius: "6px",
//                         cursor: "pointer",
//                         fontSize: "12px",
//                         fontWeight: "600",
//                         fontFamily: "Outfit",
//                         transition: "background-color 0.2s ease",
//                         whiteSpace: "nowrap",
//                       }}
//                       onMouseEnter={(e) => {
//                         e.target.style.backgroundColor = "#7c3aed";
//                       }}
//                       onMouseLeave={(e) => {
//                         e.target.style.backgroundColor = "#9048FB";
//                       }}
//                     >
//                       Click Me
//                     </Button>
//                   </TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         {/* Pagination */}
//         {totalPages > 1 && (
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               p: { xs: 2, sm: 3, md: "24px 32px" },
//               borderTop: "1px solid #f0f1f3",
//               backgroundColor: "white",
//             }}
//           >
//             <Typography
//               variant="body2"
//               sx={{
//                 color: "#6B7280",
//                 fontFamily: "Outfit",
//                 fontSize: { xs: "12px", sm: "14px" },
//               }}
//             >
//               Showing {startIndex + 1} to{" "}
//               {Math.min(endIndex, filteredCompanies.length)} of{" "}
//               {filteredCompanies.length} companies
//             </Typography>

//             <Pagination
//               count={totalPages}
//               page={currentPage}
//               onChange={handlePageChange}
//               size={isXs ? "small" : "medium"}
//               sx={{
//                 "& .MuiPaginationItem-root": {
//                   fontFamily: "Outfit",
//                   fontSize: { xs: "12px", sm: "14px" },
//                 },
//                 "& .Mui-selected": {
//                   backgroundColor: "#9048FB !important",
//                   color: "white",
//                 },
//                 "& .MuiPaginationItem-root:hover": {
//                   backgroundColor: "#f3f4f6",
//                 },
//               }}
//             />
//           </Box>
//         )}
//       </Paper>
//     </Box>
//   );

//   return <TableView />;
// };

// export default CompaniesTable;

// import {
//   Box,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   useTheme,
//   useMediaQuery,
//   Card,
//   CardContent,
//   Typography,
//   Grid,
//   Stack,
//   Chip as MuiChip,
//   Pagination,
//   Button,
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import React, { useEffect, useMemo } from "react";

// import {
//   fetchCompanies,
//   setCurrentPage,
//   clearError,
// } from "../redux/slices/companiesSlice";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward"; // Import arrow icon

// const CompaniesTable = ({ selectedStatus, searchQuery }) => {
//   const theme = useTheme();
//   const isXs = useMediaQuery(theme.breakpoints.down("sm"));
//   const isSm = useMediaQuery(theme.breakpoints.between("sm", "md"));
//   const isMd = useMediaQuery(theme.breakpoints.between("md", "lg"));
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   // Get state from Redux store
//   const { companies, loading, error, currentPage, itemsPerPage } = useSelector(
//     (state) => state.companies
//   );

//   // Fetch companies data on component mount
//   useEffect(() => {
//     dispatch(fetchCompanies());
//   }, [dispatch]);

//   // Filter companies based on status and search query
//   const filteredCompanies = useMemo(() => {
//     let filtered = companies;

//     // Filter by status
//     if (selectedStatus !== "All") {
//       filtered = filtered.filter(
//         (company) => company.activityStatus === selectedStatus
//       );
//     }

//     // Filter by search query (search in company name)
//     if (searchQuery.trim() !== "") {
//       filtered = filtered.filter((company) =>
//         company.name.toLowerCase().includes(searchQuery.toLowerCase())
//       );
//     }

//     return filtered;
//   }, [companies, selectedStatus, searchQuery]);

//   // Pagination calculations using filtered companies
//   const totalPages = Math.ceil(filteredCompanies.length / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const endIndex = startIndex + itemsPerPage;
//   const currentCompanies = filteredCompanies.slice(startIndex, endIndex);

//   // Reset to first page when filters change
//   useEffect(() => {
//     dispatch(setCurrentPage(1));
//   }, [selectedStatus, searchQuery, dispatch]);

//   // Handle page change
//   const handlePageChange = (event, value) => {
//     dispatch(setCurrentPage(value));
//   };

//   const getStatusColor = (status) => {
//     return status === "Active"
//       ? { backgroundColor: "#05CD99", color: "#FFFFFF" }
//       : { backgroundColor: "#FF6767", color: "#FFFFFF" };
//   };

//   const Chip = ({ label, style }) => (
//     <span
//       style={{
//         display: "inline-block",
//         padding: "4px 10px",
//         borderRadius: "12px",
//         fontSize: "12px",
//         fontWeight: "500",
//         whiteSpace: "nowrap",
//         ...style,
//       }}
//     >
//       {label}
//     </span>
//   );

//   const headers = [
//     "Name",
//     "Admin Email",
//     "Registration date",
//     "Country",
//     "Website",
//     "Company Size",
//     "Team",
//     "Activity Status",
//     "Post a Job",
//     "Import Candidates",
//     "Conduct Assessment",
//     "Build Recruitment Pipeline",
//     "Details",
//   ];

//   // Loading state
//   if (loading) {
//     return (
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "400px",
//           fontSize: "16px",
//           color: "#64748b",
//         }}
//       >
//         Loading companies...
//       </Box>
//     );
//   }

//   // Error state
//   if (error) {
//     return (
//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "400px",
//           fontSize: "16px",
//           color: "#ef4444",
//           gap: 2,
//         }}
//       >
//         <div>Error: {error}</div>
//         <Button
//           onClick={() => dispatch(fetchCompanies())}
//           variant="contained"
//           color="primary"
//         >
//           Retry
//         </Button>
//       </Box>
//     );
//   }

//   // No results state
//   if (filteredCompanies.length === 0 && companies.length > 0) {
//     return (
//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "400px",
//           fontSize: "16px",
//           color: "#64748b",
//           gap: 2,
//           ml: { xs: 0, sm: 0, md: 4, lg: "238px" },
//         }}
//       >
//         <Typography>No companies found matching your criteria</Typography>
//       </Box>
//     );
//   }

//   // Mobile Card View
//   const MobileCardView = () => (
//     <Box sx={{ p: 2 }}>
//       <Typography
//         variant="h5"
//         sx={{ mb: 3, fontWeight: 700, color: "#2B3674", fontFamily: "Outfit" }}
//       >
//         All Companies
//       </Typography>

//       {/* Results count */}
//       <Typography variant="body2" sx={{ mb: 2, color: "#6B7280" }}>
//         Showing {filteredCompanies.length} companies
//       </Typography>

//       {/* Mobile Cards */}
//       <Grid container spacing={2}>
//         {currentCompanies.map((company, index) => (
//           <Grid item xs={12} key={company.id}>
//             <Card sx={{ boxShadow: 1, borderRadius: 2 }}>
//               <CardContent>
//                 <Stack spacing={2}>
//                   <Box
//                     sx={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "center",
//                     }}
//                   >
//                     <Typography
//                       variant="h6"
//                       sx={{ color: "#3b82f6", fontWeight: 500 }}
//                     >
//                       {company.name}
//                     </Typography>
//                     <Chip
//                       label={company.activityStatus}
//                       style={getStatusColor(company.activityStatus)}
//                     />
//                   </Box>

//                   <Typography variant="body2" color="text.secondary">
//                     {company.email}
//                   </Typography>

//                   <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//                     <Chip
//                       label={`Size: ${company.companySize}`}
//                       style={{ backgroundColor: "#dbeafe", color: "#1e40af" }}
//                     />
//                     <Chip
//                       label={company.country}
//                       style={{ backgroundColor: "#dcfce7", color: "#16a34a" }}
//                     />
//                     <Chip
//                       label={`Jobs: ${company.postJob}`}
//                       style={{
//                         backgroundColor:
//                           company.postJob > 0 ? "#4BC7E1" : "#E5E7EB",
//                         color: company.postJob > 0 ? "#FFFFFF" : "#6B7280",
//                         fontSize: "10px",
//                         height: "20px",
//                       }}
//                     />
//                     <Chip
//                       label={`Candidates: ${company.importCandidates}`}
//                       style={{
//                         backgroundColor:
//                           company.importCandidates > 0 ? "#4BC7E1" : "#E5E7EB",
//                         color:
//                           company.importCandidates > 0 ? "#FFFFFF" : "#6B7280",
//                         fontSize: "10px",
//                         height: "20px",
//                       }}
//                     />
//                     <Chip
//                       label={`Assessment: ${company.conductAssessment}`}
//                       style={{
//                         backgroundColor:
//                           company.conductAssessment > 0 ? "#4BC7E1" : "#E5E7EB",
//                         color:
//                           company.conductAssessment > 0 ? "#FFFFFF" : "#6B7280",
//                         fontSize: "10px",
//                         height: "20px",
//                       }}
//                     />
//                     <Chip
//                       label={`Pipeline: ${company.buildRecruitmentPipeline}`}
//                       style={{
//                         backgroundColor:
//                           company.buildRecruitmentPipeline > 0
//                             ? "#4BC7E1"
//                             : "#E5E7EB",
//                         color:
//                           company.buildRecruitmentPipeline > 0
//                             ? "#FFFFFF"
//                             : "#6B7280",
//                         fontSize: "10px",
//                         height: "20px",
//                       }}
//                     />
//                     <Chip
//                       label={`Team: ${company.teamMemberCount}`}
//                       style={{ backgroundColor: "#fef3c7", color: "#d97706" }}
//                     />
//                   </Box>

//                   <Typography variant="caption" color="text.secondary">
//                     {company.website}
//                   </Typography>
//                 </Stack>
//               </CardContent>
//             </Card>
//           </Grid>
//         ))}
//       </Grid>

//       {/* Mobile Pagination */}
//       {totalPages > 1 && (
//         <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
//           <Pagination
//             count={totalPages}
//             page={currentPage}
//             onChange={handlePageChange}
//             size="small"
//             sx={{
//               "& .MuiPaginationItem-root": {
//                 fontFamily: "Outfit",
//               },
//             }}
//           />
//         </Box>
//       )}
//     </Box>
//   );

//   // Desktop/Tablet Table View
//   const TableView = () => (
//     <Box
//       sx={{
//         p: { xs: 1, sm: 2, md: 3 },
//         backgroundColor: "#fff",
//         ml: { xs: 0, sm: 0, md: 4, lg: "238px" },
//         fontFamily:
//           "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
//       }}
//     >
//       <Paper
//         sx={{
//           backgroundColor: "white",
//           borderRadius: "8px",
//           boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
//           overflow: "hidden",
//         }}
//       >
//         {/* Table Container with Custom Scrollbar */}
//         <TableContainer
//           sx={{
//             overflowX: "auto",
//             // Custom scrollbar styles
//             "&::-webkit-scrollbar": {
//               height: "8px",
//             },
//             "&::-webkit-scrollbar-track": {
//               background: "#f1f5f9",
//               borderRadius: "4px",
//             },
//             "&::-webkit-scrollbar-thumb": {
//               background: "linear-gradient(135deg, #9048FB 0%, #7c3aed 100%)",
//               borderRadius: "4px",
//               transition: "background 0.3s ease",
//             },
//             "&::-webkit-scrollbar-thumb:hover": {
//               background: "linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)",
//             },
//             // For Firefox
//             scrollbarWidth: "thin",
//             scrollbarColor: "#9048FB #f1f5f9",
//           }}
//         >
//           <Table sx={{ minWidth: { xs: 800, sm: 1000, md: 1200 } }}>
//             <TableHead>
//               <TableRow sx={{ backgroundColor: "#fafbfc" }}>
//                 {headers.map((header, index) => {
//                   // Hide some columns on smaller screens
//                   if (
//                     isSm &&
//                     (index === 2 || index === 3 || index === 6 || index === 10)
//                   )
//                     return null;
//                   if (isMd && (index === 2 || index === 6)) return null;

//                   return (
//                     <TableCell
//                       key={index}
//                       sx={{
//                         p: { xs: "12px 8px", sm: "14px 12px", md: "16px 20px" },
//                         fontWeight: "500",
//                         fontSize: { xs: "12px", sm: "13px" },
//                         color: "#A3AED0",
//                         borderBottom: "1px solid #f1f5f9",
//                         whiteSpace: "nowrap",
//                         fontFamily: "Outfit",
//                       }}
//                     >
//                       <Box
//                         sx={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: "6px",
//                         }}
//                       >
//                         {header}
//                         {index < 10 && (
//                           <svg
//                             width="14"
//                             height="14"
//                             viewBox="0 0 14 14"
//                             fill="none"
//                           >
//                             <path
//                               d="M7 4L9 6H5L7 4ZM7 10L5 8H9L7 10Z"
//                               fill="#CBD5E1"
//                             />
//                           </svg>
//                         )}
//                       </Box>
//                     </TableCell>
//                   );
//                 })}
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {currentCompanies.map((company, index) => (
//                 <TableRow
//                   key={company.id}
//                   sx={{
//                     borderBottom: "1px solid #f8fafc",
//                     backgroundColor: "white",
//                   }}
//                 >
//                   {/* Name */}
//                   <TableCell
//                     sx={{
//                       p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
//                       minWidth: "200px",
//                       maxWidth: "250px",
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: "12px",
//                       }}
//                     >
//                       <span
//                         style={{
//                           color: "#9048FB",
//                           fontSize: "15px",
//                           fontWeight: "600",
//                           fontFamily: "Outfit",
//                           whiteSpace: "nowrap",
//                           overflow: "hidden",
//                           textOverflow: "ellipsis",
//                           display: "block",
//                           maxWidth: "100%",
//                         }}
//                       >
//                         {company.name}
//                       </span>
//                     </Box>
//                   </TableCell>

//                   {/* Email */}
//                   <TableCell
//                     sx={{
//                       p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
//                       fontSize: { xs: "13px", sm: "14px" },
//                       color: "#34394B",
//                       fontFamily: "Outfit",
//                       fontWeight: 400,
//                     }}
//                   >
//                     {company.email}
//                   </TableCell>

//                   {/* Registration Date - Hidden on sm */}
//                   {!isSm && (
//                     <TableCell
//                       sx={{
//                         p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
//                         fontSize: { xs: "13px", sm: "14px" },
//                         color: "#34394B",
//                         fontFamily: "Outfit",
//                         fontWeight: 400,
//                       }}
//                     >
//                       {company.registrationDate}
//                     </TableCell>
//                   )}

//                   {/* Country - Hidden on sm */}
//                   {!isSm && (
//                     <TableCell
//                       sx={{
//                         p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
//                         fontSize: { xs: "13px", sm: "14px" },
//                         color: "#34394B",
//                         fontFamily: "Outfit",
//                         fontWeight: 400,
//                       }}
//                     >
//                       {company.country}
//                     </TableCell>
//                   )}

//                   {/* Website */}
//                   <TableCell
//                     sx={{
//                       p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
//                       fontSize: { xs: "13px", sm: "14px" },
//                       color: "#34394B",
//                       fontFamily: "Outfit",
//                       fontWeight: 400,
//                     }}
//                   >
//                     {company.website !== "N/A" ? (
//                       <svg
//                         width="16"
//                         height="16"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         style={{
//                           cursor: "pointer",
//                           color: "#9048FB",
//                         }}
//                         onClick={() => {
//                           const url = company.website.startsWith("http")
//                             ? company.website
//                             : `https://${company.website}`;
//                           window.open(url, "_blank");
//                         }}
//                       >
//                         <path
//                           d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
//                           stroke="currentColor"
//                           strokeWidth="2"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                         />
//                         <polyline
//                           points="15,3 21,3 21,9"
//                           stroke="currentColor"
//                           strokeWidth="2"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                         />
//                         <line
//                           x1="10"
//                           y1="14"
//                           x2="21"
//                           y2="3"
//                           stroke="currentColor"
//                           strokeWidth="2"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                         />
//                       </svg>
//                     ) : (
//                       "-"
//                     )}
//                   </TableCell>

//                   {/* Company Size */}
//                   <TableCell
//                     sx={{ p: { xs: "12px 8px", sm: "16px 12px", md: "20px" } }}
//                   >
//                     <Chip
//                       label={company.companySize}
//                       style={{
//                         backgroundColor: "#4BC7E1",
//                         color: "#FFFFFF",
//                         fontFamily: "Roboto",
//                         fontSize: "14px",
//                       }}
//                     />
//                   </TableCell>
//                   <TableCell
//                     sx={{
//                       p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
//                       fontSize: { xs: "13px", sm: "14px" },
//                       color: "#34394B",
//                       fontFamily: "Outfit",
//                       fontWeight: 400,
//                       textAlign: "center",
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         gap: "4px",
//                       }}
//                     >
//                       <span
//                         style={{
//                           backgroundColor:
//                             company.teamMemberCount > 0 ? "#4BC7E1" : "#E5E7EB",
//                           color:
//                             company.teamMemberCount > 0 ? "#FFFFFF" : "#6B7280",
//                           padding: "4px 8px",
//                           borderRadius: "12px",
//                           fontSize: "12px",
//                           fontWeight: "500",
//                           minWidth: "24px",
//                           textAlign: "center",
//                         }}
//                       >
//                         {company.teamMemberCount}
//                       </span>
//                     </Box>
//                   </TableCell>
//                   {/* Activity Status */}
//                   <TableCell
//                     sx={{ p: { xs: "12px 8px", sm: "16px 12px", md: "20px" } }}
//                   >
//                     <Chip
//                       label={company.activityStatus}
//                       style={{
//                         ...getStatusColor(company.activityStatus),
//                         color: "#FFFFFF",
//                         fontFamily: "Roboto",
//                         fontSize: "14px",
//                       }}
//                     />
//                   </TableCell>

//                   {/* Post a Job */}
//                   <TableCell
//                     sx={{
//                       p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
//                       fontSize: { xs: "13px", sm: "14px" },
//                       color: "#34394B",
//                       fontFamily: "Outfit",
//                       fontWeight: 400,
//                       textAlign: "center",
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         gap: "4px",
//                       }}
//                     >
//                       <span
//                         style={{
//                           backgroundColor:
//                             company.postJob > 0 ? "#4BC7E1" : "#E5E7EB",
//                           color: company.postJob > 0 ? "#FFFFFF" : "#6B7280",
//                           padding: "4px 8px",
//                           borderRadius: "12px",
//                           fontSize: "12px",
//                           fontWeight: "500",
//                           minWidth: "24px",
//                           textAlign: "center",
//                         }}
//                       >
//                         {company.postJob}
//                       </span>
//                     </Box>
//                   </TableCell>

//                   {/* Import Candidates */}
//                   <TableCell
//                     sx={{
//                       p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
//                       fontSize: { xs: "13px", sm: "14px" },
//                       color: "#34394B",
//                       fontFamily: "Outfit",
//                       fontWeight: 400,
//                       textAlign: "center",
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         gap: "4px",
//                       }}
//                     >
//                       <span
//                         style={{
//                           backgroundColor:
//                             company.importCandidates > 0
//                               ? "#4BC7E1"
//                               : "#E5E7EB",
//                           color:
//                             company.importCandidates > 0
//                               ? "#FFFFFF"
//                               : "#6B7280",
//                           padding: "4px 8px",
//                           borderRadius: "12px",
//                           fontSize: "12px",
//                           fontWeight: "500",
//                           minWidth: "24px",
//                           textAlign: "center",
//                         }}
//                       >
//                         {company.importCandidates}
//                       </span>
//                     </Box>
//                   </TableCell>

//                   {/* Conduct Assessment */}
//                   <TableCell
//                     sx={{
//                       p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
//                       fontSize: { xs: "13px", sm: "14px" },
//                       color: "#34394B",
//                       fontFamily: "Outfit",
//                       fontWeight: 400,
//                       textAlign: "center",
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         gap: "4px",
//                       }}
//                     >
//                       <span
//                         style={{
//                           backgroundColor:
//                             company.conductAssessment > 0
//                               ? "#4BC7E1"
//                               : "#E5E7EB",
//                           color:
//                             company.conductAssessment > 0
//                               ? "#FFFFFF"
//                               : "#6B7280",
//                           padding: "4px 8px",
//                           borderRadius: "12px",
//                           fontSize: "12px",
//                           fontWeight: "500",
//                           minWidth: "24px",
//                           textAlign: "center",
//                         }}
//                       >
//                         {company.conductAssessment}
//                       </span>
//                     </Box>
//                   </TableCell>

//                   {/* Build Recruitment Pipeline */}
//                   <TableCell
//                     sx={{
//                       p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
//                       fontSize: { xs: "13px", sm: "14px" },
//                       color: "#34394B",
//                       fontFamily: "Outfit",
//                       fontWeight: 400,
//                       textAlign: "center",
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         gap: "4px",
//                       }}
//                     >
//                       <span
//                         style={{
//                           backgroundColor:
//                             company.buildRecruitmentPipeline > 0
//                               ? "#4BC7E1"
//                               : "#E5E7EB",
//                           color:
//                             company.buildRecruitmentPipeline > 0
//                               ? "#FFFFFF"
//                               : "#6B7280",
//                           padding: "4px 8px",
//                           borderRadius: "12px",
//                           fontSize: "12px",
//                           fontWeight: "500",
//                           minWidth: "24px",
//                           textAlign: "center",
//                         }}
//                       >
//                         {company.buildRecruitmentPipeline}
//                       </span>
//                     </Box>
//                   </TableCell>

//                   <TableCell
//                     sx={{
//                       p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
//                       textAlign: "center",
//                     }}
//                   >
//                     {/* <Button
//                       onClick={() => {
//                         console.log("Company ID:", company.id);
//                         navigate("/TwoTabsPage", {
//                           state: { companyId: company.id, company: company },
//                         });
//                       }} */}
//                     <Button
//                       onClick={() => {
//                         console.log("Company ID:", company.id);
//                         // Store company data in localStorage for persistence
//                         localStorage.setItem(
//                           `companyData_${company.id}`,
//                           JSON.stringify({
//                             companyId: company.id,
//                             company: company,
//                             timestamp: Date.now(), // To clean old data later
//                           })
//                         );

//                         const url = `/TwoTabsPage?companyId=${company.id}`;
//                         window.open(url, "_blank");
//                       }}
//                       style={{
//                         backgroundColor: "#9048FB",
//                         color: "white",
//                         border: "none",
//                         padding: "8px 16px",
//                         borderRadius: "6px",
//                         cursor: "pointer",
//                         fontSize: "12px",
//                         fontWeight: "600",
//                         fontFamily: "Outfit",
//                         transition: "background-color 0.2s ease",
//                         whiteSpace: "nowrap",
//                         display: "flex", // Important to align icon properly
//                         alignItems: "center",
//                         justifyContent: "center",
//                         minWidth: "30px",
//                       }}
//                       onMouseEnter={(e) => {
//                         e.target.style.backgroundColor = "#7c3aed";
//                       }}
//                       onMouseLeave={(e) => {
//                         e.target.style.backgroundColor = "#9048FB";
//                       }}
//                     >
//                       <ArrowForwardIcon fontSize="small" />
//                     </Button>
//                   </TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>
//         {/* Pagination */}
//         {totalPages > 1 && (
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               p: { xs: 2, sm: 3, md: "24px 32px" },
//               borderTop: "1px solid #f0f1f3",
//               backgroundColor: "white",
//             }}
//           >
//             <Typography
//               variant="body2"
//               sx={{
//                 color: "#6B7280",
//                 fontFamily: "Outfit",
//                 fontSize: { xs: "12px", sm: "14px" },
//               }}
//             >
//               Showing {startIndex + 1} to {Math.min(endIndex, companies.length)}{" "}
//               of {companies.length} companies
//             </Typography>

//             <Pagination
//               count={totalPages}
//               page={currentPage}
//               onChange={handlePageChange}
//               size={isXs ? "small" : "medium"}
//               sx={{
//                 "& .MuiPaginationItem-root": {
//                   fontFamily: "Outfit",
//                   fontSize: { xs: "12px", sm: "14px" },
//                 },
//                 "& .Mui-selected": {
//                   backgroundColor: "#9048FB !important",
//                   color: "white",
//                 },
//                 "& .MuiPaginationItem-root:hover": {
//                   backgroundColor: "#f3f4f6",
//                 },
//               }}
//             />
//           </Box>
//         )}
//       </Paper>
//     </Box>
//   );

//   return <TableView />;
// };

// export default CompaniesTable;

import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  useTheme,
  useMediaQuery,
  Card,
  CardContent,
  Typography,
  Grid,
  Stack,
  Chip as MuiChip,
  Pagination,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useMemo } from "react";

import {
  fetchCompanies,
  setCurrentPage,
  clearError,
} from "../redux/slices/companiesSlice";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"; // Import arrow icon

const CompaniesTable = ({
  selectedStatus,
  searchQuery,
  sidebarOpen = true,
}) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isMd = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Get state from Redux store
  const { companies, loading, error, currentPage, itemsPerPage } = useSelector(
    (state) => state.companies
  );

  // Calculate sidebar width based on state
  const sidebarWidth = sidebarOpen ? 217 : 100;

  // Fetch companies data on component mount
  useEffect(() => {
    dispatch(fetchCompanies());
  }, [dispatch]);

  // Filter companies based on status and search query
  const filteredCompanies = useMemo(() => {
    let filtered = companies;

    // Filter by status
    if (selectedStatus !== "All") {
      filtered = filtered.filter(
        (company) => company.activityStatus === selectedStatus
      );
    }

    // Filter by search query (search in company name)
    if (searchQuery.trim() !== "") {
      filtered = filtered.filter((company) =>
        company.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    return filtered;
  }, [companies, selectedStatus, searchQuery]);

  // Pagination calculations using filtered companies
  const totalPages = Math.ceil(filteredCompanies.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentCompanies = filteredCompanies.slice(startIndex, endIndex);

  // Reset to first page when filters change
  useEffect(() => {
    dispatch(setCurrentPage(1));
  }, [selectedStatus, searchQuery, dispatch]);

  // Handle page change
  const handlePageChange = (event, value) => {
    dispatch(setCurrentPage(value));
  };

  const getStatusColor = (status) => {
    return status === "Active"
      ? { backgroundColor: "#05CD99", color: "#FFFFFF" }
      : { backgroundColor: "#FF6767", color: "#FFFFFF" };
  };

  const Chip = ({ label, style }) => (
    <span
      style={{
        display: "inline-block",
        padding: "4px 10px",
        borderRadius: "12px",
        fontSize: "12px",
        fontWeight: "500",
        whiteSpace: "nowrap",
        ...style,
      }}
    >
      {label}
    </span>
  );

  const headers = [
    "Name",
    "Admin Email",
    "Registration date",
    "Country",
    "Website",
    "Company Size",
    "Team",
    "Activity Status",
    "Post a Job",
    "Import Candidates",
    "Conduct Assessment",
    "Build Recruitment Pipeline",
    "Details",
  ];

  // Loading state
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "400px",
          fontSize: "16px",
          color: "#64748b",
          ml: {
            xs: "0px",
            sm: "0px",
            md: `${sidebarWidth}px`,
            xl: `${sidebarWidth}px`,
          },
          transition: "margin-left 0.3s ease",
        }}
      >
        Loading companies...
      </Box>
    );
  }

  // Error state
  if (error) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "400px",
          fontSize: "16px",
          color: "#ef4444",
          gap: 2,
          ml: {
            xs: "0px",
            sm: "0px",
            md: `${sidebarWidth}px`,
            xl: `${sidebarWidth}px`,
          },
          transition: "margin-left 0.3s ease",
        }}
      >
        <div>Error: {error}</div>
        <Button
          onClick={() => dispatch(fetchCompanies())}
          variant="contained"
          color="primary"
        >
          Retry
        </Button>
      </Box>
    );
  }

  // No results state
  if (filteredCompanies.length === 0 && companies.length > 0) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "400px",
          fontSize: "16px",
          color: "#64748b",
          gap: 2,
          ml: {
            xs: "0px",
            sm: "0px",
            md: `${sidebarWidth}px`,
            xl: `${sidebarWidth}px`,
          },
          transition: "margin-left 0.3s ease",
        }}
      >
        <Typography>No companies found matching your criteria</Typography>
      </Box>
    );
  }

  // Mobile Card View
  const MobileCardView = () => (
    <Box sx={{ p: 2 }}>
      <Typography
        variant="h5"
        sx={{ mb: 3, fontWeight: 700, color: "#2B3674", fontFamily: "Outfit" }}
      >
        All Companies
      </Typography>

      {/* Results count */}
      <Typography variant="body2" sx={{ mb: 2, color: "#6B7280" }}>
        Showing {filteredCompanies.length} companies
      </Typography>

      {/* Mobile Cards */}
      <Grid container spacing={2}>
        {currentCompanies.map((company, index) => (
          <Grid item xs={12} key={company.id}>
            <Card sx={{ boxShadow: 1, borderRadius: 2 }}>
              <CardContent>
                <Stack spacing={2}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{ color: "#3b82f6", fontWeight: 500 }}
                    >
                      {company.name}
                    </Typography>
                    <Chip
                      label={company.activityStatus}
                      style={getStatusColor(company.activityStatus)}
                    />
                  </Box>

                  <Typography variant="body2" color="text.secondary">
                    {company.email}
                  </Typography>

                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                    <Chip
                      label={`Size: ${company.companySize}`}
                      style={{ backgroundColor: "#dbeafe", color: "#1e40af" }}
                    />
                    <Chip
                      label={company.country}
                      style={{ backgroundColor: "#dcfce7", color: "#16a34a" }}
                    />
                    <Chip
                      label={`Jobs: ${company.postJob}`}
                      style={{
                        backgroundColor:
                          company.postJob > 0 ? "#4BC7E1" : "#E5E7EB",
                        color: company.postJob > 0 ? "#FFFFFF" : "#6B7280",
                        fontSize: "10px",
                        height: "20px",
                      }}
                    />
                    <Chip
                      label={`Candidates: ${company.importCandidates}`}
                      style={{
                        backgroundColor:
                          company.importCandidates > 0 ? "#4BC7E1" : "#E5E7EB",
                        color:
                          company.importCandidates > 0 ? "#FFFFFF" : "#6B7280",
                        fontSize: "10px",
                        height: "20px",
                      }}
                    />
                    <Chip
                      label={`Assessment: ${company.conductAssessment}`}
                      style={{
                        backgroundColor:
                          company.conductAssessment > 0 ? "#4BC7E1" : "#E5E7EB",
                        color:
                          company.conductAssessment > 0 ? "#FFFFFF" : "#6B7280",
                        fontSize: "10px",
                        height: "20px",
                      }}
                    />
                    <Chip
                      label={`Pipeline: ${company.buildRecruitmentPipeline}`}
                      style={{
                        backgroundColor:
                          company.buildRecruitmentPipeline > 0
                            ? "#4BC7E1"
                            : "#E5E7EB",
                        color:
                          company.buildRecruitmentPipeline > 0
                            ? "#FFFFFF"
                            : "#6B7280",
                        fontSize: "10px",
                        height: "20px",
                      }}
                    />
                    <Chip
                      label={`Team: ${company.teamMemberCount}`}
                      style={{ backgroundColor: "#fef3c7", color: "#d97706" }}
                    />
                  </Box>

                  <Typography variant="caption" color="text.secondary">
                    {company.website}
                  </Typography>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Mobile Pagination */}
      {totalPages > 1 && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            size="small"
            sx={{
              "& .MuiPaginationItem-root": {
                fontFamily: "Outfit",
              },
            }}
          />
        </Box>
      )}
    </Box>
  );

  // Desktop/Tablet Table View
  const TableView = () => (
    <Box
      sx={{
        p: { xs: 1, sm: 2, md: 3 },
        backgroundColor: "#fff",
        ml: {
          xs: "0px",
          sm: "0px",
          md: `${sidebarWidth}px`,
          xl: `${sidebarWidth}px`,
        },
        transition: "margin-left 0.3s ease",
        fontFamily:
          "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      }}
    >
      <Paper
        sx={{
          backgroundColor: "white",
          borderRadius: "8px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          overflow: "hidden",
        }}
      >
        {/* Table Container with Custom Scrollbar */}
        <TableContainer
          sx={{
            overflowX: "auto",
            // Custom scrollbar styles
            "&::-webkit-scrollbar": {
              height: "8px",
            },
            "&::-webkit-scrollbar-track": {
              background: "#f1f5f9",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "linear-gradient(135deg, #9048FB 0%, #7c3aed 100%)",
              borderRadius: "4px",
              transition: "background 0.3s ease",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              background: "linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)",
            },
            // For Firefox
            scrollbarWidth: "thin",
            scrollbarColor: "#9048FB #f1f5f9",
          }}
        >
          <Table sx={{ minWidth: { xs: 800, sm: 1000, md: 1200 } }}>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#fafbfc" }}>
                {headers.map((header, index) => {
                  // Hide some columns on smaller screens
                  if (
                    isSm &&
                    (index === 2 || index === 3 || index === 6 || index === 10)
                  )
                    return null;
                  if (isMd && (index === 2 || index === 6)) return null;

                  return (
                    <TableCell
                      key={index}
                      sx={{
                        p: { xs: "12px 8px", sm: "14px 12px", md: "16px 20px" },
                        fontWeight: "500",
                        fontSize: { xs: "12px", sm: "13px" },
                        color: "#A3AED0",
                        borderBottom: "1px solid #f1f5f9",
                        whiteSpace: "nowrap",
                        fontFamily: "Outfit",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        {header}
                        {index < 10 && (
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                          >
                            <path
                              d="M7 4L9 6H5L7 4ZM7 10L5 8H9L7 10Z"
                              fill="#CBD5E1"
                            />
                          </svg>
                        )}
                      </Box>
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {currentCompanies.map((company, index) => (
                <TableRow
                  key={company.id}
                  sx={{
                    borderBottom: "1px solid #f8fafc",
                    backgroundColor: "white",
                  }}
                >
                  {/* Name */}
                  <TableCell
                    sx={{
                      p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
                      minWidth: "200px",
                      maxWidth: "250px",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      <span
                        style={{
                          color: "#9048FB",
                          fontSize: "15px",
                          fontWeight: "600",
                          fontFamily: "Outfit",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "block",
                          maxWidth: "100%",
                        }}
                      >
                        {company.name}
                      </span>
                    </Box>
                  </TableCell>

                  {/* Email */}
                  <TableCell
                    sx={{
                      p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
                      fontSize: { xs: "13px", sm: "14px" },
                      color: "#34394B",
                      fontFamily: "Outfit",
                      fontWeight: 400,
                    }}
                  >
                    {company.email}
                  </TableCell>

                  {/* Registration Date - Hidden on sm */}
                  {!isSm && (
                    <TableCell
                      sx={{
                        p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
                        fontSize: { xs: "13px", sm: "14px" },
                        color: "#34394B",
                        fontFamily: "Outfit",
                        fontWeight: 400,
                      }}
                    >
                      {company.registrationDate}
                    </TableCell>
                  )}

                  {/* Country - Hidden on sm */}
                  {!isSm && (
                    <TableCell
                      sx={{
                        p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
                        fontSize: { xs: "13px", sm: "14px" },
                        color: "#34394B",
                        fontFamily: "Outfit",
                        fontWeight: 400,
                      }}
                    >
                      {company.country}
                    </TableCell>
                  )}

                  {/* Website */}
                  <TableCell
                    sx={{
                      p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
                      fontSize: { xs: "13px", sm: "14px" },
                      color: "#34394B",
                      fontFamily: "Outfit",
                      fontWeight: 400,
                    }}
                  >
                    {company.website !== "N/A" ? (
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        style={{
                          cursor: "pointer",
                          color: "#9048FB",
                        }}
                        onClick={() => {
                          const url = company.website.startsWith("http")
                            ? company.website
                            : `https://${company.website}`;
                          window.open(url, "_blank");
                        }}
                      >
                        <path
                          d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <polyline
                          points="15,3 21,3 21,9"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <line
                          x1="10"
                          y1="14"
                          x2="21"
                          y2="3"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    ) : (
                      "-"
                    )}
                  </TableCell>

                  {/* Company Size */}
                  <TableCell
                    sx={{ p: { xs: "12px 8px", sm: "16px 12px", md: "20px" } }}
                  >
                    <Chip
                      label={company.companySize}
                      style={{
                        backgroundColor: "#4BC7E1",
                        color: "#FFFFFF",
                        fontFamily: "Roboto",
                        fontSize: "14px",
                      }}
                    />
                  </TableCell>
                  <TableCell
                    sx={{
                      p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
                      fontSize: { xs: "13px", sm: "14px" },
                      color: "#34394B",
                      fontFamily: "Outfit",
                      fontWeight: 400,
                      textAlign: "center",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "4px",
                      }}
                    >
                      <span
                        style={{
                          backgroundColor:
                            company.teamMemberCount > 0 ? "#4BC7E1" : "#E5E7EB",
                          color:
                            company.teamMemberCount > 0 ? "#FFFFFF" : "#6B7280",
                          padding: "4px 8px",
                          borderRadius: "12px",
                          fontSize: "12px",
                          fontWeight: "500",
                          minWidth: "24px",
                          textAlign: "center",
                        }}
                      >
                        {company.teamMemberCount}
                      </span>
                    </Box>
                  </TableCell>
                  {/* Activity Status */}
                  <TableCell
                    sx={{ p: { xs: "12px 8px", sm: "16px 12px", md: "20px" } }}
                  >
                    <Chip
                      label={company.activityStatus}
                      style={{
                        ...getStatusColor(company.activityStatus),
                        color: "#FFFFFF",
                        fontFamily: "Roboto",
                        fontSize: "14px",
                      }}
                    />
                  </TableCell>

                  {/* Post a Job */}
                  <TableCell
                    sx={{
                      p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
                      fontSize: { xs: "13px", sm: "14px" },
                      color: "#34394B",
                      fontFamily: "Outfit",
                      fontWeight: 400,
                      textAlign: "center",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "4px",
                      }}
                    >
                      <span
                        style={{
                          backgroundColor:
                            company.postJob > 0 ? "#4BC7E1" : "#E5E7EB",
                          color: company.postJob > 0 ? "#FFFFFF" : "#6B7280",
                          padding: "4px 8px",
                          borderRadius: "12px",
                          fontSize: "12px",
                          fontWeight: "500",
                          minWidth: "24px",
                          textAlign: "center",
                        }}
                      >
                        {company.postJob}
                      </span>
                    </Box>
                  </TableCell>

                  {/* Import Candidates */}
                  <TableCell
                    sx={{
                      p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
                      fontSize: { xs: "13px", sm: "14px" },
                      color: "#34394B",
                      fontFamily: "Outfit",
                      fontWeight: 400,
                      textAlign: "center",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "4px",
                      }}
                    >
                      <span
                        style={{
                          backgroundColor:
                            company.importCandidates > 0
                              ? "#4BC7E1"
                              : "#E5E7EB",
                          color:
                            company.importCandidates > 0
                              ? "#FFFFFF"
                              : "#6B7280",
                          padding: "4px 8px",
                          borderRadius: "12px",
                          fontSize: "12px",
                          fontWeight: "500",
                          minWidth: "24px",
                          textAlign: "center",
                        }}
                      >
                        {company.importCandidates}
                      </span>
                    </Box>
                  </TableCell>

                  {/* Conduct Assessment */}
                  <TableCell
                    sx={{
                      p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
                      fontSize: { xs: "13px", sm: "14px" },
                      color: "#34394B",
                      fontFamily: "Outfit",
                      fontWeight: 400,
                      textAlign: "center",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "4px",
                      }}
                    >
                      <span
                        style={{
                          backgroundColor:
                            company.conductAssessment > 0
                              ? "#4BC7E1"
                              : "#E5E7EB",
                          color:
                            company.conductAssessment > 0
                              ? "#FFFFFF"
                              : "#6B7280",
                          padding: "4px 8px",
                          borderRadius: "12px",
                          fontSize: "12px",
                          fontWeight: "500",
                          minWidth: "24px",
                          textAlign: "center",
                        }}
                      >
                        {company.conductAssessment}
                      </span>
                    </Box>
                  </TableCell>

                  {/* Build Recruitment Pipeline */}
                  <TableCell
                    sx={{
                      p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
                      fontSize: { xs: "13px", sm: "14px" },
                      color: "#34394B",
                      fontFamily: "Outfit",
                      fontWeight: 400,
                      textAlign: "center",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "4px",
                      }}
                    >
                      <span
                        style={{
                          backgroundColor:
                            company.buildRecruitmentPipeline > 0
                              ? "#4BC7E1"
                              : "#E5E7EB",
                          color:
                            company.buildRecruitmentPipeline > 0
                              ? "#FFFFFF"
                              : "#6B7280",
                          padding: "4px 8px",
                          borderRadius: "12px",
                          fontSize: "12px",
                          fontWeight: "500",
                          minWidth: "24px",
                          textAlign: "center",
                        }}
                      >
                        {company.buildRecruitmentPipeline}
                      </span>
                    </Box>
                  </TableCell>

                  <TableCell
                    sx={{
                      p: { xs: "12px 8px", sm: "16px 12px", md: "20px" },
                      textAlign: "center",
                    }}
                  >
                    <Button
                      onClick={() => {
                        console.log("Company ID:", company.id);
                        // Store company data in localStorage for persistence
                        localStorage.setItem(
                          `companyData_${company.id}`,
                          JSON.stringify({
                            companyId: company.id,
                            company: company,
                            timestamp: Date.now(), // To clean old data later
                          })
                        );

                        const url = `/TwoTabsPage?companyId=${company.id}`;
                        window.open(url, "_blank");
                      }}
                      style={{
                        backgroundColor: "#9048FB",
                        color: "white",
                        border: "none",
                        padding: "8px 16px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        fontSize: "12px",
                        fontWeight: "600",
                        fontFamily: "Outfit",
                        transition: "background-color 0.2s ease",
                        whiteSpace: "nowrap",
                        display: "flex", // Important to align icon properly
                        alignItems: "center",
                        justifyContent: "center",
                        minWidth: "30px",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#7c3aed";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "#9048FB";
                      }}
                    >
                      <ArrowForwardIcon fontSize="small" />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {/* Pagination */}
        {totalPages > 1 && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: { xs: 2, sm: 3, md: "24px 32px" },
              borderTop: "1px solid #f0f1f3",
              backgroundColor: "white",
            }}
          >
            <Typography
              variant="body2"
              sx={{
                color: "#6B7280",
                fontFamily: "Outfit",
                fontSize: { xs: "12px", sm: "14px" },
              }}
            >
              Showing {startIndex + 1} to {Math.min(endIndex, companies.length)}{" "}
              of {companies.length} companies
            </Typography>

            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              size={isXs ? "small" : "medium"}
              sx={{
                "& .MuiPaginationItem-root": {
                  fontFamily: "Outfit",
                  fontSize: { xs: "12px", sm: "14px" },
                },
                "& .Mui-selected": {
                  backgroundColor: "#9048FB !important",
                  color: "white",
                },
                "& .MuiPaginationItem-root:hover": {
                  backgroundColor: "#f3f4f6",
                },
              }}
            />
          </Box>
        )}
      </Paper>
    </Box>
  );

  return <TableView />;
};

export default CompaniesTable;
